import { Component, inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { MatIconButton, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { TranslatePipe } from "@ngx-translate/core";
import { DialogHeaderComponent } from "../../../../shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-new-zone-confirm-dialog",
  templateUrl: "./new-zone-confirm-dialog.component.html",
  styleUrls: ["./new-zone-confirm-dialog.component.scss"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatDialogActions,
    MatButton,
    DialogHeaderComponent
  ]
})
export class NewZoneConfirmDialogComponent {
  dialogRef = inject<MatDialogRef<NewZoneConfirmDialogComponent>>(MatDialogRef);
  data = inject<{}>(MAT_DIALOG_DATA);

  newZoneForm: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl("", Validators.required)
  });

  submit() {
    this.dialogRef.close({
      zone: this.newZoneForm.value,
      draw: true
    });
  }

  cancel() {
    this.dialogRef.close({ draw: false });
  }
}
